function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import useThemeProps from "../../hooks/useThemeProps";

function SvgCustomizeOutlinedIcon(props) {
  var c = useThemeProps();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: props.size || '1em',
    height: props.size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.27 8.25-.02-.019a.79.79 0 0 0-1.116 0l-3.033 3.034-.058.086-.523 1.286a.263.263 0 0 0 .343.343l1.287-.522.087-.058 3.033-3.033a.79.79 0 0 0 0-1.116Zm-.289.83-2.996 2.997-.938.38.38-.939 2.996-2.995c.16-.16.421-.233.606-.048.16.16.146.412-.048.606Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.5 12.003.344-.14 2.96-2.959a.258.258 0 0 0 .085-.157.116.116 0 0 0-.037-.096.109.109 0 0 0-.101-.034.282.282 0 0 0-.151.082l-2.96 2.96-.14.344Zm2.458-3.949a1.04 1.04 0 0 1 1.47 0l.019.02a1.04 1.04 0 0 1 0 1.47l-3.051 3.05-.13.086-1.31.532a.513.513 0 0 1-.667-.67l.532-1.308.086-.129 3.05-3.05ZM9 14.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5ZM1 1.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5ZM2 2v4h4V2H2ZM9 1.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5Zm1 .5v4h4V2h-4ZM1 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5Zm1 .5v4h4v-4H2Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }));
}

SvgCustomizeOutlinedIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var Memo = /*#__PURE__*/memo(SvgCustomizeOutlinedIcon);
export default Memo;